import { ChevronDownIcon } from "lucide-react";

import { Row } from "@/components/Row";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { TabsTrigger } from "@/components/ui/tabs";

import { getScreenFromPathname, mixpanelUtils } from "@/lib/mixpanel/mixpanel";
import { cn } from "@/lib/utils";

export const MoreTabDropdownItem = ({
  tabs,
  value,
}: {
  tabs: { count?: number; label: string; value: string }[];
  value: string;
}) => {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <TabsTrigger
          value={value}
          className="w-[45px]"
          data-state={
            tabs.some((tab) => tab.value === value) ? "active" : "inactive"
          }
        >
          <ChevronDownIcon className="h-4 w-4" />
        </TabsTrigger>
      </DropdownMenuTrigger>
      <DropdownMenuContent className="bg-slate-100 text-sm">
        {tabs.map((tab) => (
          <DropdownMenuItem key={tab.value}>
            <TabsTrigger
              className={cn(
                "justify-start text-slate-500 hover:bg-slate-100",
                tab.value === value ? "" : "w-full", // Allow selection on entire row while not having a white background cover full row on selection
              )}
              value={tab.value}
              onClick={() => {
                mixpanelUtils.trackTabView(
                  getScreenFromPathname(window.location.pathname),
                  tab.value,
                );
              }}
            >
              <TabLabel label={tab.label} count={tab.count} />
            </TabsTrigger>
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

const TabLabel = ({ label, count }: { label: string; count?: number }) => {
  const displayCount = count
    ? count > 9
      ? "9+"
      : count > 0
        ? String(count)
        : null
    : null;
  return (
    <Row className="items-center gap-1">
      <p>{label}</p>
      {displayCount && (
        <Row className="h-4 w-4 items-center justify-center rounded-full bg-slate-200">
          <p className="text-[10px] text-slate-700">{displayCount}</p>
        </Row>
      )}
    </Row>
  );
};
